import React, { useEffect, useState } from "react";
import Container from "../../../../../layouts/containers/Container";
import "./invoicesReport.scss";
import baseUrl from "../../../../../api/baseUrl";
import { useNavigate, useParams } from "react-router-dom";
function Invoices() {
  const [data, setdata] = useState([]);
  const { ID } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    baseUrl
      .get("/payment/getPaymentByPatient", {
        headers: {
          patientid: ID,
        },
      })
      .then((response) => {
        setdata(response.data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [ID]);
  const handleAddInvoice = () => {
    baseUrl
      .post("treatment/create-treatment", {
        patientId: ID,
      })
      .then((response) => {
        navigate(`/client/payment/invoice/${response.data.data._id}`);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const gotoInvoice = (e: any) => {
    navigate(`/client/payment/invoice/${e}`);
  };
  return (
    <Container className="invoices-report">
      <div className="header">
        Invoices
        <button onClick={() => handleAddInvoice()}>Add New</button>
      </div>
      <table>
        <thead>
          <tr>
            <th>regNo</th>
            <th>patient</th>
            <th>total </th>
            <th>discount</th>
            <th>paid </th>
            <th>balance </th>
            <th>status </th>
            <th>date</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item: any, i: number) => (
            <tr key={i} onClick={() => gotoInvoice(item?._id)}>
              <td data-label="Invoice No">{item?.invoiceNo}</td>
              <td data-label="Patient">{item?.fullName}</td>
              <td data-label="Total">{item?.total}</td>
              <td data-label="Discount">{item?.discount}</td>
              <td data-label="Paid">{item?.card + item?.cash}</td>
              <td data-label="Balance">{item?.due}</td>
              <td data-label="Status">{item?.due === 0 ? "Completed" : item?.due > 0 ? "Due" : "Paid"}</td>
              <td data-label="Date">{item?.updatedAt.split("T")[0]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}

export default Invoices;
